// import { ArrowDownIcon, ArrowUpIcon, MixerHorizontalIcon } from '@radix-ui/react-icons';
// import { useEffect, useState } from 'react';
// import api from '../../lib/api';
// import { Badge } from '../ui/badge';
// import { Button } from '../ui/button';
// import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
// import { DropdownMenuItem } from '../ui/dropdown-menu';
// import { ScrollArea } from '../ui/scroll-area';

// const RearrangeStartNumbersDialog = ({ data, fetchClass, dropdown }) => {
//     const [list, setList] = useState([]);

//     useEffect(() => {
//         // Sort data when modal opens: registrations with `startNumber` first, and `null` startNumbers last
//         const sortedData = [...data].sort((a, b) => {
//             if (a.crossedOut) return 1;  // Crossed-out items go to the bottom
//             if (b.crossedOut) return -1;
//             if (a.startNumber === null) return 1;  // Null values go to the bottom
//             if (b.startNumber === null) return -1;
//             return a.startNumber - b.startNumber;  // Otherwise, sort by startNumber
//         });
//         setList(sortedData);
//     }, [data]);

//     // Function to move an item up in the list
//     const moveUp = (index) => {
//         if (index === 0) return; // Already at the top
//         const newList = [...list];
//         const temp = newList[index - 1];
//         newList[index - 1] = newList[index];
//         newList[index] = temp;
//         setList(newList);
//     };

//     // Function to move an item down in the list
//     const moveDown = (index) => {
//         if (index === list.length - 1) return; // Already at the bottom
//         const newList = [...list];
//         const temp = newList[index + 1];
//         newList[index + 1] = newList[index];
//         newList[index] = temp;
//         setList(newList);
//     };

//     // Handle submit logic
//     const handleSubmit = async () => {
//         const classId = list[0].classId;

//         // Create array of { registrationId, startNumber } for registrations, excluding crossed-out items
//         const registrations = list
//             .filter(item => !item.crossedOut)  // Exclude crossed-out registrations
//             .map((item, index) => ({
//                 registrationId: item.registrationId,
//                 startNumber: index + 1, // Assign start number based on new index
//             }));

//         // Prepare final data structure
//         const postData = {
//             classId: classId,
//             registrations: registrations
//         };

//         // API call to submit the start numbers
//         try {
//             const response = await api.post('https://skhrf-api.cmdigital.se/v1/registrations/change-startnumber', postData);

//             fetchClass(); // Refresh the class data
//         } catch (error) {
//             console.error('Error submitting start numbers:', error);
//         }
//     };

//     return (
//         <Dialog>
//             {dropdown ? (
//                 <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
//                     <DialogTrigger className='flex items-center w-full text-left'>
//                         <MixerHorizontalIcon className='mr-3' /> Ändra startordning
//                     </DialogTrigger>
//                 </DropdownMenuItem>
//             ) : (
//                 <DialogTrigger className='flex items-center w-full' asChild>
//                     <Button>
//                         <MixerHorizontalIcon className='mr-3' /> Ändra startordning
//                     </Button>
//                 </DialogTrigger>
//             )}
//             <DialogContent>
//                 <DialogHeader>
//                     <DialogTitle>Ändra startordning</DialogTitle>
//                 </DialogHeader>

//                 <div className="space-y-4">
//                     <ScrollArea className="h-fit max-h-screen rounded-md">
//                         {list.map((item, index) => (
//                             <div key={item.registrationId} className="flex items-center justify-between p-3 mt-3 text-sm border rounded-md">
//                                 <div>
//                                     {item.bunny.name} - {item.driver.first_name} {item.driver.last_name} {item.crossedOut ? <Badge variant='destructive' >Struken</Badge> : ''}
//                                 </div>
//                                 <div className="flex space-x-2">
//                                     {/* Move up button */}
//                                     <Button onClick={() => moveUp(index)} disabled={index === 0 || item.crossedOut}>
//                                         <ArrowUpIcon />
//                                     </Button>

//                                     {/* Move down button */}
//                                     <Button onClick={() => moveDown(index)} disabled={index === list.length - 1 || item.crossedOut}>
//                                         <ArrowDownIcon />
//                                     </Button>
//                                 </div>
//                             </div>
//                         ))}
//                     </ScrollArea>
//                 </div>

//                 {/* Submit button */}
//                 <div className="mt-4 grid grid-cols-2">
//                     <Button onClick={handleSubmit} className='col-start-2'>
//                         Uppdatera startordning
//                     </Button>
//                 </div>
//             </DialogContent>
//         </Dialog>
//     );
// };

// export default RearrangeStartNumbersDialog;

import { MixerHorizontalIcon, UpdateIcon } from '@radix-ui/react-icons';
import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { DropdownMenuItem } from '../ui/dropdown-menu';
import { Input } from '../ui/input';
import { ScrollArea } from '../ui/scroll-area';
import { toast } from '../ui/use-toast';

const RearrangeStartNumbersDialog = ({ data, fetchClass, dropdown }) => {
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Sort data when modal opens: registrations with `startNumber` first, and `null` startNumbers last
        const sortedData = [...data].sort((a, b) => {
            if (a.crossedOut) return 1;  // Crossed-out items go to the bottom
            if (b.crossedOut) return -1;
            if (a.startNumber === null) return 1;  // Null values go to the bottom
            if (b.startNumber === null) return -1;
            return a.startNumber - b.startNumber;  // Otherwise, sort by startNumber
        });
        setList(sortedData);
    }, [data]);

    // Handle input change for start numbers
    const handleStartNumberChange = (index, value) => {
        const newList = [...list];
        newList[index].startNumber = value ? parseInt(value, 10) : null;
        setList(newList);
    };

    // Handle blur event to clear conflicting start numbers
    const handleBlur = (index) => {
        const newList = [...list];
        const newStartNumber = newList[index].startNumber;

        if (newStartNumber !== null) {
            // Check for duplicates and resolve conflicts
            newList.forEach((item, i) => {
                if (i !== index && item.startNumber === newStartNumber) {
                    item.startNumber = null;
                }
            });
            setList(newList);
        }
    };

    // Handle submit logic
    const handleSubmit = async () => {
        setIsLoading(true);

        const classId = list[0].classId;

        // Separate crossed-out and active registrations
        const activeRegistrations = list.filter(item => !item.crossedOut);
        const crossedOutRegistrations = list.filter(item => item.crossedOut);

        // Sort active registrations by assigned start numbers
        let registrations = activeRegistrations.sort((a, b) => (a.startNumber || Infinity) - (b.startNumber || Infinity));

        // Assign start numbers to bunnies without a start number, ensuring sequential order
        let currentStartNumber = 1;
        registrations = registrations.map(item => {
            if (item.startNumber === null) {
                // Find the next available start number
                while (registrations.some(reg => reg.startNumber === currentStartNumber)) {
                    currentStartNumber++;
                }
                return { ...item, startNumber: currentStartNumber++ };
            }
            return item;
        });

        // Ensure all start numbers are sequential
        registrations.sort((a, b) => a.startNumber - b.startNumber);
        registrations = registrations.map((item, index) => ({
            ...item,
            startNumber: index + 1
        }));

        // Combine active and crossed-out registrations
        const finalRegistrations = [
            ...registrations.map(item => ({
                registrationId: item.registrationId,
                startNumber: item.startNumber,
            })),
            ...crossedOutRegistrations.map(item => ({
                registrationId: item.registrationId,
                startNumber: null,
            }))
        ];

        // Prepare final data structure
        const postData = {
            classId: classId,
            registrations: finalRegistrations,
        };

        try {
            const response = await api.post('https://skhrf-api.cmdigital.se/v1/registrations/change-startnumber', postData);

            fetchClass();
            toast({
                title: 'Startnummer uppdaterade',
            });
        } catch (error) {
            console.error('Error submitting start numbers:', error);
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog>
            {dropdown ? (
                <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                    <DialogTrigger className='flex items-center w-full text-left'>
                        <MixerHorizontalIcon className='mr-3' /> Ändra startordning
                    </DialogTrigger>
                </DropdownMenuItem>
            ) : (
                <DialogTrigger className='flex items-center w-full' asChild>
                    <Button>
                        <MixerHorizontalIcon className='mr-3' /> Ändra startordning
                    </Button>
                </DialogTrigger>
            )}
            <DialogContent className='max-h-dvh'>
                <DialogHeader className='text-left'>
                    <DialogTitle>Ändra startordning</DialogTitle>
                    <DialogDescription>Alla startnummer behöver inte anges, STAMP kommer automatiskt att anpassa till lediga startnummer eller lägga ekipaget sist i klassen. Tänk på att strukna kaniner inte kommer få ett startnummer.</DialogDescription>
                </DialogHeader>
                <div className="space-y-2">
                    <ScrollArea className="h-[calc(50dvh)] rounded-md" type='always'>
                        {list.map((item, index) => (
                            <div key={item.registrationId} className="grid grid-cols-5 items-center justify-between p-2 mt-3 mr-3 text-sm border rounded-md">
                                <div className='col-span-4'>
                                    {item.bunny.name} - {item.driver.first_name} {item.driver.last_name} {item.crossedOut ? <Badge variant='destructive'>Struken</Badge> : ''}
                                </div>
                                <div className="flex space-x-2">
                                    <Input
                                        type="number"
                                        id={`startNumber-${item.registrationId}`}
                                        value={item.startNumber || ''}
                                        onChange={(e) => handleStartNumberChange(index, e.target.value)}
                                        onBlur={() => handleBlur(index)}
                                        // disabled={item.crossedOut}
                                        placeholder="Nr"
                                        autoComplete='off'
                                    />
                                </div>
                            </div>
                        ))}
                    </ScrollArea>
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button
                        className='col-start-2'
                        onClick={handleSubmit}
                        disabled={isLoading}>
                        {(isLoading) ? <UpdateIcon className='loader-spinner' /> : <>Uppdatera startordning</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default RearrangeStartNumbersDialog;
